import React, { Component } from "react";
import styled, { keyframes } from "styled-components";
import { NavLink } from "react-router-dom";
import Loader from "./Loader";
import PanelWrapper from "./layout/PanelWrapper";
import Moment from "react-moment";
import he from "he";

class FeedbackItem extends Component {
  render() {
    return (
      <PanelWrapper>
        <ReviewHeader>
          {he.decode(this.props.reviewer)}{" "}
          <ReviewDate>
            <Moment parse="YYYYMMDD" format="DD/MM/YYYY">
              {this.props.date}
            </Moment>
          </ReviewDate>
        </ReviewHeader>
        <ReviewBody>
          {this.props.loading ? (
            <Loader color="#00ff00" />
          ) : (
            he.decode(this.props.reviewText)
          )}
        </ReviewBody>
      </PanelWrapper>
    );
  }
}

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const ReviewHeader = styled.h1`
  color: #ffc300;
  padding: 0;
  margin: 0;
  text-transform: uppercase;
  font-size: 18px;
  font-weight: normal;
  animation: ${props => (props.out ? fadeIn : fadeIn)} 0.3s linear;
  transition: visibility 1s linear;
`;

const ReviewDate = styled.span`
  font-size: 14px;
  color: #ffffff;
  animation: ${props => (props.out ? fadeIn : fadeIn)} 0.3s linear;
  transition: visibility 1s linear;
`;

const ReviewBody = styled.div`
  color: #ffffff;
  font-family: "Open Sans", sans-serif;
  font-weight: 300;
  font-size: 14px;
  padding: 0;
  animation: ${props => (props.out ? fadeIn : fadeIn)} 0.3s linear;
  transition: visibility 1s linear;
`;

const Link = styled.a`
  margin: 0;
  padding: 2px 15px;
  color: #000000;
  background: #fdba03;
  text-transform: uppercase;
  font-size: 13px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  animation: ${props => (props.out ? fadeIn : fadeIn)} 0.3s linear;
  transition: visibility 1s linear;
`;

const NaviLink = styled(NavLink)`
  margin: 0;
  padding: 2px 15px;
  color: #000000;
  background: #fdba03;
  text-transform: uppercase;
  font-size: 13px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  animation: ${props => (props.out ? fadeIn : fadeIn)} 0.3s linear;
  transition: visibility 1s linear;
`;

const ButtonContainer = styled.div`
  display: block;
  text-align: right;
  padding: 5px 0 0 0;
`;

export default FeedbackItem;



// WEBPACK FOOTER //
// ./src/components/FeedbackItem.js